import {
  LICENSE_DATA_REQUEST_ASYNC,
  RESET_SELECTED_ADDONS,
  TOGGLE_ADDON_TO_UNLOCK,
} from './constants'

const getLicenseInformation = () => ({
  type: LICENSE_DATA_REQUEST_ASYNC.INITIATE,
})
export const getLicenseInformationSuccess = (data) => ({
  type: LICENSE_DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getLicenseInformationError = (error) => ({
  type: LICENSE_DATA_REQUEST_ASYNC.ERROR,
  error,
})
const getLicenseInformationCancel = () => ({
  type: LICENSE_DATA_REQUEST_ASYNC.CANCEL,
})

const toggleAddonToUnlock = (addon) => ({
  type: TOGGLE_ADDON_TO_UNLOCK,
  payload: { addon },
})

const resetSelectedAddons = () => ({
  type: RESET_SELECTED_ADDONS,
})

export default {
  // to props
  getLicenseInformation,
  getLicenseInformationCancel,
  toggleAddonToUnlock,
  resetSelectedAddons,
}
